
<div class="loader" *ngIf="loading_page"></div>
<section id="contact-h" class="bg-parallax contact-h-bg">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="contact-h-cont">
          <h3 class="cl-white">
            Queremos empezar a ayudarte, contactanos
          </h3>
          <br />
          <form
          name="form"
          #f="ngForm"
          (ngSubmit)="f.form.valid && sendMailToContact()"
          novalidate
          >
            <div class="form-group cl-white">
              <label for="name">Nombre</label>
              <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                name
                required
                #name="ngModel"
                required
                aria-describedby="nameHelp"
                placeholder="Ingresa tú nombre por favor"
                [(ngModel)]="nombre" [ngModelOptions]="{standalone: true}"
                [ngClass]="{ 'is-invalid': f.submitted && email.errors }"
              />
              <div *ngIf="f.submitted && name.errors" class="invalid-feedback">
                <div *ngIf="name.errors['required']">El nombre es obligatorio</div>
              </div>
            </div>


            <div class="form-group cl-white">
              <label for="exampleInputEmail1">Correo</label>
              <input
                type="email"
                class="form-control"
                name="email"
                required
                email
                #email="ngModel"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Ingresa tú correo"
                [(ngModel)]="correo" [ngModelOptions]="{standalone: true}"
                [ngClass]="{ 'is-invalid': f.submitted && email.errors }"
              />
              <div *ngIf="f.submitted && email.errors" class="invalid-feedback">
                <div *ngIf="email.errors['required']">El correo es obligatorio</div>
                <div *ngIf="email.errors['email']">El correo es invalido</div>
              </div>
            </div>


            <div class="form-group cl-white">
              <label for="exampleInputCelular1">Celular</label>
              <input
                type="text"
                class="form-control"
                name="phone"
                required
                phone
                #phone="ngModel"
                id="exampleInputCelular1"
                aria-describedby="CelularHelp"
                placeholder="Ingresa tú celular"
                [(ngModel)]="celular" [ngModelOptions]="{standalone: true}"
                [ngClass]="{ 'is-invalid': f.submitted && phone.errors }"
              />
              <div *ngIf="f.submitted && phone.errors" class="invalid-feedback">
                <div *ngIf="phone.errors['required']">El celular es obligatorio</div>
              </div>
            </div>
            <div class="form-group cl-white">
              <label for="subject">Asunto</label>
              <input
                type="text"
                class="form-control"
                id="subject"
                name="subject"
                required
                subject
                #subject="ngModel"
                aria-describedby="subjectHelp"
                placeholder="Ingresa el asunto"
                [(ngModel)]="asunto" [ngModelOptions]="{standalone: true}"
                [ngClass]="{ 'is-invalid': f.submitted && subject.errors }"
              />
              <div *ngIf="f.submitted && subject.errors" class="invalid-feedback">
                <div *ngIf="subject.errors['required']">El asunto es obligatorio</div>
              </div>
            </div>
            <div class="form-group cl-white">
              <label for="message">Mensaje</label>
              <textarea class="form-control" id="message" rows="3"
              name="message"
              required
              message
              #message="ngModel"
              [(ngModel)]="mensaje"  [ngModelOptions]="{standalone: true}"
              [ngClass]="{ 'is-invalid': f.submitted && message.errors }"
              ></textarea>
              <div *ngIf="f.submitted && message.errors" class="invalid-feedback">
                <div *ngIf="message.errors['required']">El asunto es obligatorio</div>
              </div>
            </div>
            <button   type="submit" class="btn btn-general btn-white" role="button" >
              <i fa fa-right-arrow></i>Envíar mensaje
            </button>
            <div *ngIf="loading">
              Enviando Mensaje...
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

